var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.keywords.length
    ? _c("div", { staticClass: "filter-item filter-item--keywords" }, [
        _c("h2", {
          staticClass: "filter-item__heading",
          domProps: { textContent: _vm._s(_vm.translations.title) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-item__keywords" },
          _vm._l(_vm.keywords, function(keyWord, keyWordKey) {
            return _c(
              "div",
              {
                key: keyWordKey,
                staticClass: "keyword-item",
                class: {
                  "keyword-item--active":
                    _vm.isActive(keyWord) || _vm.noItemsSelected
                },
                on: {
                  click: function($event) {
                    _vm.selectKeyword(keyWord)
                  }
                }
              },
              [_c("span", { domProps: { textContent: _vm._s(keyWord.name) } })]
            )
          })
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-expand",
            class: { "show-all": _vm.showNonStarred },
            on: {
              click: function($event) {
                _vm.showNonStarred = !_vm.showNonStarred
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 223 395.65"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"
                  }
                })
              ]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb8fe356", { render: render, staticRenderFns: staticRenderFns })
  }
}